import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ce7da6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-filter" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" data-v-4ce7da6b><title data-v-4ce7da6b></title><g data-name=\"Layer 2\" id=\"Layer_2\" data-v-4ce7da6b><path d=\"M28,9H11a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z\" data-v-4ce7da6b></path><path d=\"M7,9H4A1,1,0,0,1,4,7H7A1,1,0,0,1,7,9Z\" data-v-4ce7da6b></path><path d=\"M21,17H4a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z\" data-v-4ce7da6b></path><path d=\"M11,25H4a1,1,0,0,1,0-2h7a1,1,0,0,1,0,2Z\" data-v-4ce7da6b></path><path d=\"M9,11a3,3,0,1,1,3-3A3,3,0,0,1,9,11ZM9,7a1,1,0,1,0,1,1A1,1,0,0,0,9,7Z\" data-v-4ce7da6b></path><path d=\"M23,19a3,3,0,1,1,3-3A3,3,0,0,1,23,19Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,23,15Z\" data-v-4ce7da6b></path><path d=\"M13,27a3,3,0,1,1,3-3A3,3,0,0,1,13,27Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,13,23Z\" data-v-4ce7da6b></path><path d=\"M28,17H25a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Z\" data-v-4ce7da6b></path><path d=\"M28,25H15a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z\" data-v-4ce7da6b></path></g><g id=\"frame\" data-v-4ce7da6b><rect class=\"cls-1\" height=\"32\" width=\"32\" data-v-4ce7da6b></rect></g></svg>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "filter-box"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Kategorien", -1))
const _hoisted_6 = { class: "container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Maximaler Zeitaufwand", -1))
const _hoisted_8 = { class: "time-container" }
const _hoisted_9 = ["onClick"]

import FilterItem from '../components/FilterItem.vue';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilter',
  setup(__props) {

const store = useStore()

let searchInput = ref('');
let timeInput = ref(0);
let showFilters = ref(false);

const filterTags = computed(() => store.getters.getTags)

const timeSlots = [15, 30, 45, 60]

function toggleFilters () {
    showFilters.value = !showFilters.value
}

function updateSearch() {
    store.commit('setSearchTerm', searchInput.value);
}

function updateTimeFilter(timeSlot: number) {
    timeInput.value = timeSlot;
    store.commit('setTimeFilter', timeSlot);
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "search",
        id: "search",
        placeholder: "Suchen...",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchInput) ? (searchInput).value = $event : searchInput = $event)),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (updateSearch()))
      }, null, 544), [
        [_vModelText, _unref(searchInput)]
      ]),
      _createElementVNode("button", {
        class: "filter-toggle",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleFilters()))
      }, _hoisted_3)
    ]),
    (_unref(showFilters))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterTags), (tag) => {
              return (_openBlock(), _createBlock(FilterItem, {
                key: tag.slug,
                tag: tag
              }, null, 8, ["tag"]))
            }), 128))
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeSlots, (slot) => {
              return _createElementVNode("span", {
                class: _normalizeClass(["time-item", { selected: _unref(timeInput) == slot}]),
                key: slot,
                onClick: ($event: any) => (updateTimeFilter(slot))
              }, _toDisplayString(slot) + " Minuten", 11, _hoisted_9)
            }), 64)),
            _createElementVNode("span", {
              class: _normalizeClass(["time-item", { selected: _unref(timeInput) == 0}]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (updateTimeFilter(0)))
            }, "Alle", 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})